import {
  type IReference,
  type IReferenceValue,
} from '../../references/IReference.ts';

/**
 * `{ [variableId]: IReferenceValue }`
 *
 * Struttura centralizzata per la gestione delle variabili presenti in
 * un'espressione. A partire dalle `Reference` e dai valori associati,
 * viene registrata la coppia ID/valore.
 *
 * A livello di variableId, abbiamo due casi:
 *  1. Variabili del Form/Widget: in questo caso, il variableId è l'ID del widget
 *  2. Variabili di Context: in questo caso, il variableId è il codice, es. `valore_sessione_1`
 *
 * A livello di creazione, abbiamo anche qui due casi:
 * 1. In caso di `parentWhen`
 * 2. In caso di `useWatch` (nello specifico `useWatchReferences`)
 *
 * In entrambi i casi i `values` sono un array, quindi possiamo usare
 * `createExpressionVariables` per creare la struttura.
 */
export type IEvaluationVariables = Record<string, IReferenceValue>;

export function createEvaluationVariables(
  references: IReference[],
  values: any[],
): IEvaluationVariables {
  const variables: IEvaluationVariables = {};
  for (let i = 0; i < references.length; i++) {
    variables[references[i].id] = values[i];
  }
  return variables;
}
